export const MimeTypeToFriendlyName = (mimeType: string) => {
  switch (mimeType) {
    case 'image/doc':
    case 'image/docx':
      return 'Word Document'

    case 'image/pdf':
      return 'PDF'
    case 'image/jpg':
    case 'image/jpeg':
    case 'image/jpe':
    case 'image/png':
    case 'image/gif':
    case 'image/webp':
    case 'image/tiff':
    case 'image/tif':
    case 'image/psd':
    case 'image/raw':
    case 'image/bmp':
    case 'image/heif':
    case 'image/jp2':
    case 'image/j2k':
    case 'image/svg':
    case 'image/svgz':
    case 'image/ai':
    case 'image/eps':
    case 'image/jpf':
    case 'image/jpx':
    case 'image/jpm':
    case 'image/mj2':
    case 'image/heic':
    case 'image/dib':
    case 'image/arw':
    case 'image/cr2':
    case 'image/nrw':
    case 'image/k25':
      return 'Picture'
    default:
      return ''
  }
}
